export default function constructUrl(url) {
    if (window.accuvars.language.iso_code === 'en') {
        return url
    }

    let finalUrl = url

    if (!url.startsWith('http')) {
        if (!url.startsWith(`/${window.accuvars.language.iso_code}/`)) {
            finalUrl = `/${window.accuvars.language.iso_code}${url}`
        }

        return finalUrl
    }

    if (!url.startsWith(window.accuvars.baseURI)) {
        return finalUrl
    }

    finalUrl = new URL(finalUrl)

    if (!finalUrl.pathname.startsWith(`/${window.accuvars.language.iso_code}/`)) {
        finalUrl.pathname = `/${window.accuvars.language.iso_code}${finalUrl.pathname}`
    }

    return finalUrl.toString()
}
